"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cAcceptedValidationRulesPerInputType = exports.cBaseFileSizeMultiplier = exports.cBaseFileSizeUnit = exports.cSchemaLessInputTypes = exports.formI18nErrors = exports.cInputTypeAliases = exports.cFormAllValidationRules = exports.cFormCustomValidators = exports.cFormCommonValidationRules = void 0;
/**
 * These are validation rules that require no extra context.
 */
exports.cFormCommonValidationRules = Object.freeze({
    /**
     * Whether this is a required field.
     */
    required: 'required',
    email: 'email',
    numeric: 'numeric',
    min: 'min',
    max: 'max',
    /**
     * Whether this field should be validated as a URL.
     */
    url: 'url',
    isLink: 'isLink',
    between: 'between',
    file_types: 'file_types',
    /**
     * TODO test this
     * The maximum file size in KB allowed in this field.
     */
    size: 'size',
    /**
     * TODO test this
     * The id of the user list which this application must target.
     */
    applicationTargetMatchesList: 'applicationTargetMatchesList',
    /**
     * TODO test this
     * For repeaters, whether to not allow duplicates (i.e., when true,
     * duplicates are not allowed).
     */
    filterDuplicatesByKey: 'filterDuplicatesByKey',
});
/**
 * Validation rules that need extra context, to be retrieved by some async
 * callback that cannot be known in advance by acb-lib.
 *
 * For now, they're only defined on the front-end, but
 * they could be defined on the back-end as well, if we
 * implement validation there too (which we should do, one day).
 *
 * They cannot live here (in `acb-lib`) as they need ACB data.
 *
 * For example, `slug_valid` needs to check for existing slugs,
 * which means an API request from the front end, or a just DB call from
 * the API. We can't write any of that here.
 *
 */
exports.cFormCustomValidators = Object.freeze({
    is_unique: 'is_unique',
    /**
     * Whether this field should contain a string which can be used as a slug.
     */
    slug_valid: 'slug_valid',
    feed_valid: 'feed_valid',
    /**
     * TODO test format + can this be common?
     * The date which this field's value may not be before, format 'dd/MM/yyyy'
     */
    date_before: 'date_before',
    /**
     * TODO test this
     */
    notification_ownership: 'notification_ownership',
    /**
     * TODO test format + can this be common?
     * The date which this field's value may not be beyond, format 'dd/MM/yyyy'
     */
    date_after: 'date_after',
    /**
     * TODO Is this needed now we've got zod?
     */
    max_custom: 'max_custom',
    /**
     * TODO Is this needed now we've got zod?
     */
    min_custom: 'min_custom',
    /**
     * TODO test this
     */
    emailWithNameParentheses: 'emailWithNameParentheses',
    /**
     * TODO can this go into common validators?
     * The maximum length of the html content of the field.
     */
    maxHtml: 'maxHtml',
});
exports.cFormAllValidationRules = Object.freeze(__assign(__assign({}, exports.cFormCommonValidationRules), exports.cFormCustomValidators));
exports.cInputTypeAliases = Object.freeze({
    text: [
        'textInput',
        'text',
        'number',
        'stringTemplate',
        'textarea',
        'hidden',
        'email',
        'tel',
        'password',
        'search',
        'month',
        'year',
    ],
    date: ['dateInput', 'date'],
    icon: ['icon', 'iconPicker'],
    options: ['options', 'typeAhead', 'tags'],
    membershipTags: ['membershipTags', 'membershipTagsSelector'],
});
/**
 * I wasn't sure whether to define i18n here,
 * but I think it makes sense.
 */
exports.formI18nErrors = Object.freeze({
    default: 'form.errorTypes._default',
    email: 'form.errorTypes.email',
});
/**
 * Some input types don't have a schema — it's fine. They
 * don't actually expect an input. They're just there to serve as display.
 */
exports.cSchemaLessInputTypes = Object.freeze([
    'heading',
    'paragraph',
    'title',
]);
exports.cBaseFileSizeUnit = 'KB';
exports.cBaseFileSizeMultiplier = 1e3;
/**
 * This defines the accepted validation rules for each input type.
 *
 * Note that the input types can be aliases — different input types that
 * use the same component can have different validation rules available to them.
 *
 * TODO test what happens with aliases, both in terms of types and usage.
 */
exports.cAcceptedValidationRulesPerInputType = {
    /**
     * TODO make this always available.
     */
    default: [exports.cFormAllValidationRules.required],
    date: [
        exports.cFormAllValidationRules.required,
        exports.cFormAllValidationRules.date_after,
        exports.cFormAllValidationRules.date_before,
    ],
    year: [
        exports.cFormAllValidationRules.required,
        exports.cFormAllValidationRules.min_custom,
        exports.cFormAllValidationRules.max_custom,
    ],
    text: [
        exports.cFormAllValidationRules.required,
        exports.cFormAllValidationRules.numeric,
        exports.cFormAllValidationRules.email,
        exports.cFormAllValidationRules.min,
        exports.cFormAllValidationRules.max,
        exports.cFormAllValidationRules.url,
        exports.cFormAllValidationRules.slug_valid,
        exports.cFormAllValidationRules.feed_valid,
        exports.cFormAllValidationRules.isLink,
    ],
    textarea: [
        exports.cFormAllValidationRules.required,
        exports.cFormAllValidationRules.numeric,
        exports.cFormAllValidationRules.email,
        exports.cFormAllValidationRules.min,
        exports.cFormAllValidationRules.max,
        exports.cFormAllValidationRules.url,
        exports.cFormAllValidationRules.slug_valid,
        exports.cFormAllValidationRules.feed_valid,
    ],
    number: [
        exports.cFormAllValidationRules.required,
        exports.cFormAllValidationRules.min_custom,
        exports.cFormAllValidationRules.max_custom,
        exports.cFormAllValidationRules.between,
    ],
    toggle: [exports.cFormAllValidationRules.required],
    checkbox: [
        exports.cFormAllValidationRules.required,
        exports.cFormAllValidationRules.min_custom,
        exports.cFormAllValidationRules.max_custom,
    ],
    options: [
        exports.cFormAllValidationRules.required,
        exports.cFormAllValidationRules.notification_ownership,
    ],
    wysiwyg: [
        exports.cFormAllValidationRules.required,
        exports.cFormAllValidationRules.maxHtml,
    ],
    /** TODO test this */
    files: [exports.cFormAllValidationRules.file_types, exports.cFormAllValidationRules.size],
    /** TODO test this */
    repeater: [exports.cFormAllValidationRules.filterDuplicatesByKey],
    geoLocation: [],
};
